import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
//import { initAuth } from './core/auth';
import GoogleAnalytics from 'react-ga'
import configureStore from './core/store';
import Root from './views/root';
import './views/styles/styles.scss';
const store = configureStore();
const syncedHistory = syncHistoryWithStore(browserHistory, store);
const rootElement = document.getElementById('root');
import { google_analytics_tracking_id } from './config'

const { IntlProvider } = require('react-intl')
import {messages} from './locale/en/messages'

GoogleAnalytics.initialize(google_analytics_tracking_id, {
  debug: true,
  titleCase: false,
  gaOptions: {
    userId: 123
  }
});

function logPageData() {
    GoogleAnalytics.set({ page: window.location.pathname + window.location.search });
    GoogleAnalytics.pageview(window.location.pathname + window.location.search);
}

function render(Root) {
  ReactDOM.render(
      <IntlProvider locale='en' defaultLocale='en' messages={messages}>
          <AppContainer>
            <Root history={syncedHistory} store={store} onUpdate={logPageData()} />
          </AppContainer>
      </IntlProvider>,
    rootElement
  );
}

if (module.hot) {
  module.hot.accept('./views/root', () => {
    render(require('./views/root').default);
  });
}

render(Root)



// WEBPACK FOOTER //
// ./src/main.js